export class ClinicalSignificance {
  ClinicalSignificanceID: number;
  Name: string;
  Description: string;
  ShortName: string;

  constructor(id: number, name: string) {
    this.ClinicalSignificanceID = id;
    this.Name = name;
  }
}
